<template>
  <div class="container-fluid">
    <div class="gallery-wrapper w-100 mt-5">
      <div class="row d-flex justify-content-center my-5">
        <div class="col-11 col-md-5 mx-auto">
           <u-animate-container>
              <u-animate
                name="fadeInUp"
                delay="0s"
                duration="1s"
                :iteration="1"
                :offset="-100"
                animateClass="animated"
                :begin="false"
              >
            <h2 class="serif col-blue ">
              Gallery
            </h2>
           </u-animate>
          </u-animate-container>
          <hr>
        </div>
      </div>

      <CoolLightBox
        :items="items"
        :index="index"
        :effect="'fade'"
        :thumbsPosition="'bottom'"
        @close="index = null">
      </CoolLightBox>
      <div class="images-wrapper gallery-content container">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4"   v-for="(image, imageIndex) in items"  :key="imageIndex" >
            <u-animate-container>
              <u-animate
                name="zoomIn"
                delay="0s"
                duration="1s"
                :iteration="1"
                :offset="0"
                animateClass="animated"
                :begin="false"
              >
                <div
                  class="image w-100"
                  @click="index = imageIndex"
                  :style="{ backgroundImage: 'url(' + image + ')' }"
                ></div>
                </u-animate>
              </u-animate-container>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'



export default {

  name: 'Gallery',
  components: {
    CoolLightBox,
  },
  data() {
    return {
      items: '',
      index: null,

    }
  },
  created() {
    this.items = this.$store.getters.getImages
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .image {
    // width: 33%;
    height: 30vh;
    float: left;
    background-size: cover;
    background-position: center;
    margin-bottom: 30px;
    cursor: pointer;
    cursor: finger;
  }

</style>
